var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 22.2h2.2V28c0 1.2.8 2 2 2 .4 0 1-.2 1.2-.4l9-7.4h6.2c2.8 0 5.2-2.4 5.2-5.2V7c0-2.8-2.4-5.2-5.2-5.2H5.7C2.9 2 .5 4.2.5 7.2v10c0 2.8 2.4 5 5.2 5M4.5 7.3c0-.8.6-1.2 1.2-1.2h20.4c.6 0 1.2.6 1.2 1.2v10c0 .6-.6 1.2-1.2 1.2h-6.8c-.6-.2-1 0-1.4.2l-6.2 5.2v-3.6c0-1.2-.8-2-2-2h-4c-.6 0-1.2-.6-1.2-1.2z"
  })));
};
export default SvgComment;